import { getAuthHeaders, tempMeeApi } from '~/services/api';
import type {
  ISaveWorkerClassificationApiPayload,
  TSaveWorkerClassificationApiResponse,
} from '../types/SaveWorkerType.api';

export const saveWorkerClassification = async (
  payload: ISaveWorkerClassificationApiPayload,
): Promise<TSaveWorkerClassificationApiResponse> => {
  const headers = await getAuthHeaders();
  const { data } = await tempMeeApi.patch<TSaveWorkerClassificationApiResponse>(
    '/users/worker-classification',
    payload,
    { headers },
  );
  return data;
};
